import React from 'react';
import { Link } from 'react-router-dom';
import { Users, Trophy } from 'lucide-react';
import { BRAND_GREEN, BRAND_GOLD } from '../theme/sucronTheme';
import { useSportsLang } from '../contexts/SportsLangContext';

const LABELS = {
  pt: {
    title: 'Comunidades Esportivas',
    subtitle: 'Conecte-se com atletas, treinadores e entusiastas do esporte',
    footTitle: 'Comunidade Futebol',
    footDesc: 'Discussões, análises e insights do mundo do futebol',
    swimTitle: 'Comunidade Natação',
    swimDesc: 'Nadadores, clubes, técnicos e resultados',
    members: (n) => `${n} membros`,
    join: 'Entrar →',
  },
  en: {
    title: 'Sports Communities',
    subtitle: 'Connect with athletes, coaches and sports enthusiasts',
    footTitle: 'Football Community',
    footDesc: 'Discussions, analysis and insights from the football world',
    swimTitle: 'Swimming Community',
    swimDesc: 'Swimmers, clubs, coaches and results',
    members: (n) => `${n} members`,
    join: 'Join →',
  }
};

const ComunidadesPage = () => {
  const { lang } = useSportsLang();
  const t = LABELS[lang] || LABELS.pt;

  const communities = [
    {
      to: '/futebol/comunidade',
      icon: Trophy,
      title: t.footTitle,
      description: t.footDesc,
      color: 'gray',
      members: '2.4k'
    },
    {
      to: '/natacao/comunidade',
      icon: Users,
      title: t.swimTitle,
      description: t.swimDesc,
      color: 'blue',
      members: '1.8k'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2" style={{ color: BRAND_GREEN }}>
            {t.title}
          </h1>
          <p className="text-gray-600">
            {t.subtitle}
          </p>
        </div>

        {/* Communities Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {communities.map((community) => {
            const Icon = community.icon;
            return (
              <Link
                key={community.to}
                to={community.to}
                className="group bg-white rounded-xl border border-gray-200 p-6 hover:shadow-lg transition-all duration-200"
              >
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-gray-100 rounded-lg group-hover:scale-110 transition-transform">
                    <Icon className="w-6 h-6 text-gray-700" />
                  </div>
                  
                  <div className="flex-1">
                    <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-gray-800">
                      {community.title}
                    </h3>
                    <p className="text-sm text-gray-600 mb-3">
                      {community.description}
                    </p>
                    
                    <div className="flex items-center gap-2 text-sm">
                      <span className="text-gray-500">{t.members(community.members)}</span>
                      <span className="text-gray-300">•</span>
                      <span className="font-semibold" style={{ color: BRAND_GREEN }}>
                        {t.join}
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ComunidadesPage;
